"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../elements/button/Button");
var _visuallyHiddenModule = _interopRequireDefault(require("../../style/display/visually-hidden.module.scss"));
var _addToBasketUtils = require("./addToBasketUtils");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["sendToBasket", "onBeforeAdd", "onSuccess", "onError", "shortCtaText", "className", "forceLoading", "title", "variantId", "skuId", "quantity", "clientId", "childItems", "path", "customText", "hasHeaderBasketCountEvent", "hasScreenReaderAnnouncement"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var STATE_ACTIVE = 'ACTIVE';
var STATE_ADDING = 'ADDING';
var STATE_SUCCESS = 'SUCCESS';
var STATE_TEXT = {
  ACTIVE: 'Add to your basket',
  ADDING: 'Adding to your basket',
  SUCCESS: 'Added to your basket'
};
var STATE_TEXT_SHORT = {
  ACTIVE: 'Add to basket',
  ADDING: 'Adding to basket',
  SUCCESS: 'Added to basket'
};
var AddToBasketButton = function AddToBasketButton(_ref) {
  var _ref$sendToBasket = _ref.sendToBasket,
    sendToBasket = _ref$sendToBasket === void 0 ? function (_, opts) {
      return (0, _addToBasketUtils.addToBasketRequest)(opts);
    } : _ref$sendToBasket,
    _ref$onBeforeAdd = _ref.onBeforeAdd,
    onBeforeAdd = _ref$onBeforeAdd === void 0 ? function () {
      return Promise.resolve();
    } : _ref$onBeforeAdd,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? undefined : _ref$onSuccess,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? undefined : _ref$onError,
    _ref$shortCtaText = _ref.shortCtaText,
    shortCtaText = _ref$shortCtaText === void 0 ? false : _ref$shortCtaText,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$forceLoading = _ref.forceLoading,
    forceLoading = _ref$forceLoading === void 0 ? false : _ref$forceLoading,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$variantId = _ref.variantId,
    variantId = _ref$variantId === void 0 ? undefined : _ref$variantId,
    _ref$skuId = _ref.skuId,
    skuId = _ref$skuId === void 0 ? undefined : _ref$skuId,
    _ref$quantity = _ref.quantity,
    quantity = _ref$quantity === void 0 ? 1 : _ref$quantity,
    _ref$clientId = _ref.clientId,
    clientId = _ref$clientId === void 0 ? undefined : _ref$clientId,
    _ref$childItems = _ref.childItems,
    childItems = _ref$childItems === void 0 ? undefined : _ref$childItems,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/basket/items' : _ref$path,
    _ref$customText = _ref.customText,
    customText = _ref$customText === void 0 ? undefined : _ref$customText,
    _ref$hasHeaderBasketC = _ref.hasHeaderBasketCountEvent,
    hasHeaderBasketCountEvent = _ref$hasHeaderBasketC === void 0 ? true : _ref$hasHeaderBasketC,
    _ref$hasScreenReaderA = _ref.hasScreenReaderAnnouncement,
    hasScreenReaderAnnouncement = _ref$hasScreenReaderA === void 0 ? true : _ref$hasScreenReaderA,
    rest = _objectWithoutProperties(_ref, _excluded);
  var TEXT = shortCtaText ? STATE_TEXT_SHORT : STATE_TEXT;
  var _useState = (0, _react.useState)(STATE_ACTIVE),
    _useState2 = _slicedToArray(_useState, 2),
    addToBasketState = _useState2[0],
    setAddToBasketState = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    addToBasketErrors = _useState4[0],
    setAddToBasketErrors = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    screenReaderAnnouncement = _useState6[0],
    setScreenReaderAnnouncement = _useState6[1];
  var handleErrors = function handleErrors() {
    var resJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var partialSuccess = arguments.length > 1 ? arguments[1] : undefined;
    return new Promise(function (resolve) {
      if (!resJson.errors || resJson.errors.length === 0) {
        resolve(resJson);
      } else if (onError) {
        onError(resJson, partialSuccess).then(resolve);
      } else {
        Promise.resolve().then(function () {
          return _interopRequireWildcard(require('./AddToBasketErrors'));
        }).then(function (_ref2) {
          var AddToBasketErrors = _ref2.AddToBasketErrors;
          return setAddToBasketErrors(/*#__PURE__*/(0, _jsxRuntime.jsx)(AddToBasketErrors, {
            clearAddToBasketErrors: function clearAddToBasketErrors() {
              setAddToBasketErrors(null);
              resolve(resJson);
            },
            errors: resJson.errors,
            showAsWarnings: partialSuccess
          }));
        });
      }
    });
  };
  var handleSuccess = function handleSuccess(resJson) {
    if (hasHeaderBasketCountEvent) {
      (0, _addToBasketUtils.updateHeaderBasketCount)();
    }
    if (hasScreenReaderAnnouncement) {
      setScreenReaderAnnouncement("".concat(title, " added to your basket"));
    }
    setAddToBasketState(STATE_ACTIVE);
    if (onSuccess) {
      onSuccess(resJson);
    }
  };
  var handleClick = function handleClick(event) {
    setAddToBasketState(STATE_ADDING);
    setScreenReaderAnnouncement("Adding to your basket");
    onBeforeAdd(event, {
      variantId: variantId,
      skuId: skuId,
      quantity: quantity,
      clientId: clientId,
      path: path
    }).then(sendToBasket(event, {
      variantId: variantId,
      skuId: skuId,
      quantity: quantity,
      clientId: clientId,
      childItems: childItems,
      path: path
    }).then(function () {
      var resJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (resJson.errors && resJson.errors.length > 0) {
        Promise.resolve(handleErrors(resJson, true)).then(handleSuccess);
      } else {
        handleSuccess(resJson);
      }
    }, function (resJson) {
      return Promise.resolve(handleErrors(resJson)).then(function () {
        setAddToBasketState(STATE_ACTIVE);
      });
    }));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.PrimaryButton, _objectSpread(_objectSpread({
      "aria-label": customText || TEXT[addToBasketState],
      className: className,
      disabled: forceLoading || addToBasketState === STATE_SUCCESS,
      onClick: handleClick,
      submitting: forceLoading || addToBasketState === STATE_ADDING
    }, rest), {}, {
      "data-jlds": true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: customText || TEXT.ACTIVE
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _visuallyHiddenModule.default.visuallyHidden,
        children: ", ".concat(title)
      })]
    })), addToBasketErrors, hasScreenReaderAnnouncement && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "aria-live": "assertive",
      className: _visuallyHiddenModule.default.visuallyHidden,
      role: "status",
      children: screenReaderAnnouncement
    })]
  });
};
AddToBasketButton.propTypes = {
  /** Class to apply to the button */
  className: _propTypes.default.string,
  /** Function to be called before sending the ATB request. Should return a promise. */
  onBeforeAdd: _propTypes.default.func,
  /** Function to be called when add to basket is clicked. Should return a promise containing a list of any errors. */
  sendToBasket: _propTypes.default.func,
  /** Flag to use short version text for CTA button */
  shortCtaText: _propTypes.default.bool,
  /** Flag to force show loading state (ATB->QV Lazy loading) */
  forceLoading: _propTypes.default.bool,
  /** Product title (used for screen reader text) */
  title: _propTypes.default.string.isRequired,
  /** Success callback (also handles partial success) */
  onSuccess: _propTypes.default.func,
  /** Error callback */
  onError: _propTypes.default.func,
  /** Product variantId */
  variantId: _propTypes.default.string,
  /** Product skuId */
  skuId: _propTypes.default.string,
  /** Quantity to add */
  quantity: _propTypes.default.number,
  /** ClientId for the basket services */
  clientId: _propTypes.default.string,
  /** Child Items for the basket services. It is an array of objects. Each object contains a skuId, variantId and quantity */
  childItems: _propTypes.default.array,
  /** Basket endpoint (useful to override for local development) */
  path: _propTypes.default.string,
  /** Custom text to use in the button */
  customText: _propTypes.default.string,
  /** Flag to prevent triggering the header basket count event */
  hasHeaderBasketCountEvent: _propTypes.default.bool,
  /** Flag to prevent screen reader announcements */
  hasScreenReaderAnnouncement: _propTypes.default.bool
};
var _default = exports.default = AddToBasketButton;